import * as v from "valibot";
import { LEVELS } from "../levels";

export const MAX_ID_LENGTH = 64;

export const aliasField = v.pipe(v.string(), v.minLength(1), v.maxLength(MAX_ID_LENGTH));

/** The two path parameters of an article: `/:alias/:articleId`. */
export const articleKey = {
  alias: aliasField,
  articleId: v.pipe(v.string(), v.minLength(1), v.maxLength(MAX_ID_LENGTH)),
};

export const imageDto = v.object({
  id: v.string(),
  alt: v.string(),
  src: v.string(),
  attributionHtml: v.string(),
});

export const levelDto = v.picklist(LEVELS);

export const influenceDto = v.object({ name: v.string(), influence: v.string() });

/** An author as the public sees them. */
export const authorInfoDto = v.object({
  alias: v.string(),
  expertise: v.object({
    category: v.string(),
    subcategory: v.string(),
    subjects: v.array(v.string()),
  }),
  tagline: v.string(),
  perspective: v.string(),
  mission: v.string(),
  about: v.array(v.string()),
  targetAudience: v.object({ expertise: levelDto, description: v.string() }),
  influencedBy: influenceDto,
  profileImage: v.optional(imageDto),
  followerCount: v.number(),
  publishedArticleCount: v.number(),
});
export type AuthorInfo = v.InferOutput<typeof authorInfoDto>;

/** The list item of every article list. `isBookmarked` is false for anonymous callers. */
export const searchArticleMetaDto = v.object({
  authorAlias: v.string(),
  id: v.string(),
  path: v.string(),
  image: imageDto,
  title: v.string(),
  tagline: v.string(),
  category: v.string(),
  subcategory: v.string(),
  readingMinutes: v.number(),
  updatedAt: v.number(),
  publishedAt: v.number(),
  isBookmarked: v.boolean(),
});
export type SearchArticleMeta = v.InferOutput<typeof searchArticleMetaDto>;

export const authorsByAliasDto = v.record(v.string(), authorInfoDto);
export type AuthorsByAlias = v.InferOutput<typeof authorsByAliasDto>;
